import { render, staticRenderFns } from "./Breakage.vue?vue&type=template&id=6b19ce91&"
import script from "./Breakage.vue?vue&type=script&lang=js&"
export * from "./Breakage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports